<div *ngFor="let bundle of codingBundles" class="note-type-section">
    <div class="action-heading">
        <h3 class="m-r-10">{{ bundle.label }}{{(bundle.label === 'First Consult' || bundle.label === 'Follow Up') ?
            ' (Outpatient)':''}}</h3>
        <div class="toggle-container" *ngIf="!stateUnit">
            <mat-slide-toggle [(ngModel)]="bundle.paidCash" (change)="updatePaidUpFront(bundle)" color="primary"
                [disabled]="bundle.procedureCodes.length === 0">Default
                To "Paid Up
                Front"</mat-slide-toggle>
            <mat-slide-toggle [(ngModel)]="bundle.noCharge" (change)="updateNoCharge(bundle)" color="primary"
                [disabled]="bundle.procedureCodes.length === 0">Default
                To "Pro Bono"</mat-slide-toggle>
        </div>
        <button mat-icon-button (click)="openAddBundleDialog(bundle)"
            matTooltip="Edit this coding bundle"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button *ngIf="bundle.canDelete" (click)="deleteCodingBundle(bundle.id)"
            matTooltip="Delete this coding bundle" color="warn"><mat-icon>delete</mat-icon></button>
    </div>
    <app-procedure-code-selector [initialCodes]="bundle.procedureCodes"
        (codesChanged)="onProcedureCodesChanged($event, bundle)"></app-procedure-code-selector>
</div>

<ng-template #importCodingBundlesDialog>
    <h1 mat-dialog-title>Import Coding Bundles from JSON</h1>
    <div mat-dialog-content class="p-t-10">
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>Coding Bundles JSON</mat-label>
            <textarea matInput rows="10" placeholder="Paste your Coding Bundle JSON object or array here"
                [(ngModel)]="importCodingBundlesJson" (change)="validateJson()"></textarea>
        </mat-form-field>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="importCodingBundles()">Import</button>
    </div>
</ng-template>

<ng-template #addBundleDialog>
    <h1 mat-dialog-title>Coding Bundle Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Bundle Name</mat-label>
                <input matInput [(ngModel)]="editingBundle.label" placeholder="Bundle Name" type="text" required
                    [disabled]="!editingBundle.canDelete">
            </mat-form-field>

            <div class="m-b-10" *ngIf="!stateUnit">
                <mat-slide-toggle [(ngModel)]="editingBundle.paidCash" color="primary"
                    (change)="toggleCodeStatus(editingBundle, 'up-front')">Default To "Paid Up
                    Front"</mat-slide-toggle>
            </div>

            <div class="m-b-10" *ngIf="!stateUnit">
                <mat-slide-toggle [(ngModel)]="editingBundle.noCharge" color="primary"
                    (change)="toggleCodeStatus(editingBundle, 'no-charge')">Default To "No
                    Charge"</mat-slide-toggle>
            </div>

            <app-procedure-code-selector [initialCodes]="editingBundle.procedureCodes"
                (codesChanged)="onDialogProcedureCodesChanged($event, editingBundle)"></app-procedure-code-selector>

        </div>

    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="saveBundle()" [disabled]="isLoading">Save</button>
    </div>

</ng-template>